import { injectStrict } from '~/common/inject';
import { AppDataInjectionKey } from '~/common/useAppData';
import { computed } from 'vue';
import { UserDto } from '@shared/user';

export function useSharedUser() {
  const { data } = injectStrict(AppDataInjectionKey);
  const { currentUser, sharing } = data;

  const isAccessingSharedAccount = computed(() => sharing?.type === 'shared');
  const showGlobalWarnings = computed(() => !isAccessingSharedAccount.value);

  const loggedInUser = computed<UserDto | null>(() => {
    if (!isAccessingSharedAccount.value) {
      return currentUser;
    }

    return sharing?.user ?? null;
  });

  const accountOwnerUser = computed<UserDto | null>(() => currentUser);

  const canSwitchToOwnCockpit = computed<boolean>(
    () => isAccessingSharedAccount.value && !!sharing?.hasLicence,
  );

  return {
    isAccessingSharedAccount,
    showGlobalWarnings,
    loggedInUser,
    accountOwnerUser,
    canSwitchToOwnCockpit,
  };
}
